import moment from 'moment';
import config from '../../../../config';
import { getCampaignLastSentDate } from '../campaign-utils';
var PRODUCTIVITY_THRESHOLD = 50;
var PRODUCTIVITY_DAYS_THRESHOLD = 7;
var CAMPAIGNS_SENT_DAYS_THRESHOLD = 7;
export var isEngageCtaShownForPathname = function (pathname) {
    var allowedPathnames = [{ path: /^\/appointments(?:\/.*)?$/ }, { path: /^\/barber\/appointments(?:\/.*)?$/ }];
    return allowedPathnames.some(function (_a) {
        var path = _a.path;
        return path.test(pathname);
    });
};
export var getStatisticsReportDates = function (timezone) {
    var endDate = moment.tz(timezone || config.defaultTimezone).startOf('day');
    var startDate = moment(endDate).subtract(PRODUCTIVITY_DAYS_THRESHOLD - 1, 'days');
    return {
        startDate: startDate.format(config.dateFormatISO),
        endDate: endDate.format(config.dateFormatISO),
    };
};
/**
 * show engage cta if schedule was filled less than 50% of the time in the last 7 days
 * @param productivity -- schedule productivity for the last 7 days
 */
var satisfiesProductivityTest = function (productivity) {
    if (productivity === null) {
        return false;
    }
    return productivity < PRODUCTIVITY_THRESHOLD;
};
/**
 * show engage cta if no campaigns were sent in the last 7 days
 * @param campaigns
 * @param timezone
 */
var satisfiesCampaignsTest = function (campaigns, timezone) {
    var campaignTestDate = moment
        .tz(timezone || config.defaultTimezone)
        .add(-CAMPAIGNS_SENT_DAYS_THRESHOLD, 'days')
        .startOf('day');
    return campaigns === null || campaigns === void 0 ? void 0 : campaigns.every(function (campaign) {
        var campaignLastSent = getCampaignLastSentDate(campaign, timezone);
        if (!campaignLastSent) {
            return true;
        }
        return moment.tz(campaignLastSent, timezone).isBefore(campaignTestDate);
    });
};
export var isEngageCtaNeeded = function (productivity, campaigns, timezone) {
    return satisfiesProductivityTest(productivity) && satisfiesCampaignsTest(campaigns, timezone);
};
